export class ArrayLoading{
	size: number = 0;
	type: string = "";
	arrayOptions: Array<string> = [];
}
